/**
 * T-030 — Code splitting por vertical de producto.
 * Mismo webpackChunkName agrupa páginas de una vertical en un chunk.
 */
import { lazy } from 'react';

const chunk = (name, importer) =>
  lazy(() => importer().then((m) => ({ default: m.default })));

/* ── public / marketing ── */
export const LandingPage = chunk('vertical-public', () =>
  import(/* webpackChunkName: "vertical-public" */ '../pages/LandingPage')
);
export const ClienteLandingPage = chunk('vertical-public', () =>
  import(/* webpackChunkName: "vertical-public" */ '../pages/ClienteLandingPage')
);
export const NotarioInstitutionPage = chunk('vertical-public', () =>
  import(/* webpackChunkName: "vertical-public" */ '../pages/NotarioInstitutionPage')
);
export const NotariosLandingPage = chunk('vertical-public', () =>
  import(/* webpackChunkName: "vertical-public" */ '../pages/NotariosLandingPage')
);
export const SoyNotarioPage = chunk('vertical-public', () =>
  import(/* webpackChunkName: "vertical-public" */ '../pages/SoyNotarioPage')
);
export const VerifySignaturePage = chunk('vertical-public', () =>
  import(/* webpackChunkName: "vertical-public" */ '../pages/VerifySignaturePage')
);

/* ── auth (chunk propio: login rápido sin gov/notarial) ── */
export const AuthPage = chunk('vertical-auth', () =>
  import(/* webpackChunkName: "vertical-auth" */ '../pages/auth/AuthPage')
);
export const StaffLoginPage = chunk('vertical-auth', () =>
  import(/* webpackChunkName: "vertical-auth" */ '../pages/auth/StaffLoginPage')
);
export const NotarialClientLoginPage = chunk('vertical-notarial-client', () =>
  import(/* webpackChunkName: "vertical-notarial-client" */ '../pages/notarial-client/NotarialClientLoginPage')
);

/* ── citizen ── */
export const CitizenDashboard = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/CitizenDashboard')
);
export const VaultPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/VaultPage')
);
export const ProceduresPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/ProceduresPage')
);
export const ProcedureDetailPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/ProcedureDetailPage')
);
export const RequestsListPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/RequestsListPage')
);
export const RequestDetailPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/RequestDetailPage')
);
export const PaymentPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/PaymentPage')
);
export const CitizenReportsPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/CitizenReportsPage')
);
export const CitizenProfilePage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/CitizenProfilePage')
);
export const CitizenNotificationsPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/CitizenNotificationsPage')
);
export const CitizenAppointmentsPage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/CitizenAppointmentsPage')
);
export const CitizenQueuePage = chunk('vertical-citizen', () =>
  import(/* webpackChunkName: "vertical-citizen" */ '../pages/citizen/CitizenQueuePage')
);

/* ── gov backoffice (oficina digital) ── */
export const BackofficeDashboard = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/BackofficeDashboard')
);
export const EscritorioVirtualPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/EscritorioVirtualPage')
);
export const CasesListPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/CasesListPage')
);
export const CaseDetailPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/CaseDetailPage')
);
export const DocumentsPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/DocumentsPage')
);
export const ExpedientesPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/ExpedientesPage')
);
export const ClasificacionArchivisticaPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/ClasificacionArchivisticaPage')
);
export const InboxPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/InboxPage')
);
export const AnalyticsPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/AnalyticsPage')
);
export const CorrespondenciaPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/CorrespondenciaPage')
);
export const OficiosPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/OficiosPage')
);
export const PlantillasPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/PlantillasPage')
);
export const FlujosPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/FlujosPage')
);
export const TurnadosPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/TurnadosPage')
);
export const FirmasPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/FirmasPage')
);
export const ReportesPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/ReportesPage')
);
export const MifielPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/MifielPage')
);
export const MiEfirmaPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/MiEfirmaPage')
);
export const SeguridadCuentaPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/SeguridadCuentaPage')
);
export const AreasPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/AreasPage')
);
export const UsersManagementPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/UsersManagementPage')
);
export const BandejaDetallePage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/BandejaDetallePage')
);
export const BackofficeProceduresPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/BackofficeProceduresPage')
);
export const VentanillaPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/VentanillaPage')
);
export const LibroGobiernoPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/LibroGobiernoPage')
);
export const ValijasPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/ValijasPage')
);
export const ArchivoPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/ArchivoPage')
);
export const DespachoDigitalPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/DespachoDigitalPage')
);
export const InstruccionesPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/InstruccionesPage')
);
export const InstruccionDetailPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/InstruccionDetailPage')
);
export const SemaforoCumplimientoPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/SemaforoCumplimientoPage')
);
export const AcuerdosGabinetePage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/AcuerdosGabinetePage')
);
export const IntegrationHubPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/IntegrationHubPage')
);
export const MembershipAdminPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/MembershipAdminPage')
)
export const PlatformKpisPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/PlatformKpisPage')
);
export const CabildoPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/CabildoPage')
);
export const GeospatialAnalyticsPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/backoffice/GeospatialAnalyticsPage')
);
export const GlossaryPage = chunk('vertical-gov', () =>
  import(/* webpackChunkName: "vertical-gov" */ '../pages/help/GlossaryPage')
);

/* ── notarial staff ── */
export const NotarialDashboardPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialDashboardPage')
);
export const NotarialMatterDetailPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialMatterDetailPage')
);
export const NotarialClientsPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialClientsPage')
);
export const NotarialProtocolPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialProtocolPage')
);
export const NotarialActosPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialActosPage')
);
export const NotarialPLDPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialPLDPage')
);
export const NotarialConfigPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialConfigPage')
);
export const NotarialChiapasConfigPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialChiapasConfigPage')
);
export const NotarialEntidadPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialEntidadPage')
);
export const NotarialMattersPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialMattersPage')
);
export const NotarialInstrumentsPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialInstrumentsPage')
);
export const NotarialTemplatesPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialTemplatesPage')
);
export const NotarialObligationsPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialObligationsPage')
);
export const NotarialTestimoniesPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialTestimoniesPage')
);
export const NotarialRegistriesPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialRegistriesPage')
);
export const NotarialAppointmentsPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialAppointmentsPage')
);
export const NotarialQuotesPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialQuotesPage')
);
export const NotarialCompliancePage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialCompliancePage')
);
export const NotarialPortalPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialPortalPage')
);
export const NotarialReportsPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialReportsPage')
)
export const NotarialSecurityPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialSecurityPage')
);
export const NotarialIntegrationsPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/backoffice/notaria/NotarialIntegrationsPage')
);

/* ── portal cliente notarial ── */
export const NotarialClientDashboard = chunk('vertical-notarial-client', () =>
  import(/* webpackChunkName: "vertical-notarial-client" */ '../pages/notarial-client/NotarialClientDashboard')
);
export const NotarialClientMatterPage = chunk('vertical-notarial-client', () =>
  import(/* webpackChunkName: "vertical-notarial-client" */ '../pages/notarial-client/NotarialClientMatterPage')
);

/* ── field ops ── */
export const FieldCrewMobilePage = chunk('vertical-field', () =>
  import(/* webpackChunkName: "vertical-field" */ '../pages/staff/FieldCrewMobilePage')
);
export const FieldSupervisorDashboardPage = chunk('vertical-field', () =>
  import(/* webpackChunkName: "vertical-field" */ '../pages/staff/FieldSupervisorDashboardPage')
);

/* ── instituto (gestión / supervisión notarial) ── */
export const InstitutoLandingPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/InstitutoLandingPage')
);
export const InstitutoLoginPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/InstitutoLoginPage')
);
export const InstitutoEscritorioPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/EscritorioPage')
);
export const InstitutoBandejaPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/BandejaPage')
);
export const InstitutoPadronPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/PadronPage')
);
export const InstitutoPatentesPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/PatentesPage')
);
export const InstitutoPatenteDetailPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/PatenteDetailPage')
);
export const InstitutoSellosFirmasPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/SellosFirmasPage')
);
export const InstitutoLibrosProtocolosPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/LibrosProtocolosPage')
);
export const InstitutoInspeccionesPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/InspeccionesPage')
);
export const InstitutoQuejasProcedimientosPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/QuejasProcedimientosPage')
);
export const InstitutoArchivoPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/ArchivoPage')
);
export const InstitutoTestamentosPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/TestamentosPage')
);
export const InstitutoExpedientesCompartidosPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/ExpedientesCompartidosPage')
);
export const InstitutoEstadisticaPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/EstadisticaPage')
);
export const InstitutoConfiguracionPage = chunk('vertical-institute', () =>
  import(/* webpackChunkName: "vertical-institute" */ '../pages/institute/ConfiguracionPage')
);

/* ── notarial: expedientes públicos (intercambio con Instituto) ── */
export const ExpedientesPublicosPage = chunk('vertical-notarial', () =>
  import(/* webpackChunkName: "vertical-notarial" */ '../pages/notarial/ExpedientesPublicosPage')
);
